module.exports = __webpack_public_path__ + "img/banner-referral-new.b042462f.webp";